import img1 from "../src/components/imgs/img1.jpg";
import Header from "./components/header/header";
import "./App.css";
import React from "react";
import SideBySideImages from "./components/lowhead/lowhead";
import Black from "./components/black/black";

export default function App() {
  return (
    <div className="overflow-x-hidden">
      {/* Content for small screens (phones) only */}
      <div
        className="block md:hidden relative min-h-screen bg-cover bg-center bg-fixed overflow-auto"
        style={{ backgroundImage: `url(${img1})` }}
      >
        {/* Dark overlay behind content */}
        <div className="absolute inset-0 bg-[#1b1b1b] opacity-90 z-10"></div>

        {/* Content should be on top of overlay */}
        <div className="relative z-20">
          <Header />
          <SideBySideImages />
          <Black />
        </div>
      </div>

      {/* Message for medium and larger screens (e.g., tablets, laptops) */}
      <div className="hidden md:flex items-center justify-center min-h-screen bg-gray-900 text-white text-xl">
        Please visit this site using a phone.
      </div>
    </div>
  );
}
